var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Report__field Report__field--wysiwyg"},[_c('div',[_vm._v(_vm._s(_vm.field.name))]),(_vm.submission)?_c('div',[_vm._v(" "+_vm._s(_vm.submission)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }